package com.neurobs.ccabserver.administrator.controller

import com.neurobs.ccab.db.TestRunData
import com.neurobs.js.ccab.CCABServer
import com.neurobs.js.controller.{AdminListAdapter, AdminListController, AdminPanelDelegate}
import com.neurobs.js.dom.RecordTableView
import com.neurobs.js.dom.RecordTableView.CommandLinkCell
import com.neurobs.js.view.Gui
import com.neurobs.js.util.StringUtilities.{dateString, dateTimeString}

import scala.concurrent.{Future, Promise}

class TestRunListController(testSessionId: Long, gui: Gui) extends AdminListAdapter[TestRunData] {

	override def title: String = s"Session $testSessionId Test Runs"

	override def itemName: String = "Test Run"

	override def columnHeaders: Seq[RecordTableView.ColumnHeader] = Seq(
		"Start Time",
		"Package ID",
		"Soft Ver",
		"Test ID",
		"Comp",
		"Ana",
		"Run Err",
		"Ana Err",
		""
	)

	override def itemRow(a: TestRunData, delegate: Option[AdminPanelDelegate], controller: AdminListController[TestRunData]): Seq[RecordTableView.CellContent] = Seq(
		dateTimeString(a.startTime),
		a.packageGuid.noBracketsString,
		a.softwareVersion,
		a.testId.toString,
		a.completed.map(_.toString).getOrElse(""): String,
		a.analyzed.toString,
		a.runError.getOrElse(""): String,
		a.analysisError.getOrElse(""): String,
		CommandLinkCell(text = "logfiles", () => delegate.foreach(_.newPanel(LogfileListController(a.id))))
	)

	override val create: Option[AdminListController[TestRunData] => Unit] = None

	override def get(): Future[Either[String, Seq[TestRunData]]] = {
		val promise = Promise[Either[String, Seq[TestRunData]]]
		CCABServer.getTestRuns(testSessionId) {
			case Left(error) => promise.success(Left(error.message))
			case Right(list) => promise.success(Right(list))
		}
		promise.future
	}
}

object TestRunListController {
	def apply(testSessionId: Long, gui: Gui): AdminListController[TestRunData] = new AdminListController[TestRunData](new TestRunListController(testSessionId, gui))
}